/**
 * @generated SignedSource<<849d1cd2e1569e5611d4d085d4bd1264>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyRespTopNav_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineTopAppliedFilters_user" | "SbRespSortItems_user" | "SharedFollowTopButton_user">;
  readonly " $fragmentType": "BuyRespTopNav_user";
};
export type BuyRespTopNav_user$key = {
  readonly " $data"?: BuyRespTopNav_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyRespTopNav_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyRespTopNav_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowTopButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopAppliedFilters_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8347e07472a2fa650185bc293cbdd107";

export default node;
